import { render, staticRenderFns } from "./StoreUpdateXLessonModal.vue?vue&type=template&id=4c92f58d&scoped=true&"
import script from "./StoreUpdateXLessonModal.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdateXLessonModal.vue?vue&type=script&lang=ts&"
import style0 from "./StoreUpdateXLessonModal.vue?vue&type=style&index=0&id=4c92f58d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92f58d",
  null
  
)

export default component.exports